import CONFIG from '../CONFIG.json';
import { apiFetch, buildBody, isEmpty } from './funciones';

// ----------------------------------------------------------------------

export const getProvinces = async(token) => {
    const bodyJson = JSON.stringify(buildBody(token,{}))
    const res = await apiFetch(`${CONFIG.api}province/list`,{
        method: 'POST',
        body: bodyJson,
    });
    const result = await res.json()
    if (result.error === 0 && !isEmpty(result.data)) {
        return result.data;
    }
    return [];
}

export const getOficinas = async(token) => {
    const bodyJson = JSON.stringify(buildBody(token,{}))
    const res = await apiFetch(`${CONFIG.api}oficinas/list`,{
        method: 'POST',
        body: bodyJson,
    });
    const result = await res.json()
    if (result.error === 0 && !isEmpty(result.data)) {
        return result.data;
    }
    return [];
}